"use client"

import React from "react"
import clsx from "clsx"
import { BaseStyles } from "ui/types/base-styles"
import { generateStylesFromProps } from "ui/utils/styles"

import styles from "./Switch.module.css"

const Switch = ({
  name,
  value,
  disabled,
  onChange,
  className = "",
  style = {},
  ...rest
}: {
  name: string
  value: boolean
  disabled?: boolean
  onChange: (e: { name: string; value: boolean }) => void
  className?: string
  style?: React.CSSProperties
} & BaseStyles) => {
  const generatedStyles = generateStylesFromProps(rest)

  const wrapperClasses = clsx(
    styles.wrapper,
    {
      [styles.active]: value,
      [styles.disabled]: disabled,
    },
    className,
  )

  const contentClasses = clsx(styles.content, {
    [styles.active]: value,
  })

  const wrapperStyles = {
    ...generatedStyles,
    ...style,
  }

  return (
    <div
      className={wrapperClasses}
      style={wrapperStyles}
      onClick={
        disabled
          ? () => {}
          : () =>
              onChange({
                name,
                value: !value,
              })
      }
    >
      <button className={contentClasses} />
    </div>
  )
}

export default Switch
